__turbopack_context__.v({
  "image": "_3A_4rq_image",
  "image--is-locked": "_3A_4rq_image--is-locked",
  "image-container": "_3A_4rq_image-container",
  "image-container--is-locked": "_3A_4rq_image-container--is-locked",
  "image-container--is-user-authenticated": "_3A_4rq_image-container--is-user-authenticated",
  "image-container__call-to-action": "_3A_4rq_image-container__call-to-action",
  "image-container__icon": "_3A_4rq_image-container__icon",
  "number": "_3A_4rq_number",
});
